import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { Faq } from "../components/shared/Faq";
import { LeadForm } from "../components/shared/LeadForm";
import { IpadHero } from "../components/ipad/IpadHero";
import { IpadCounter } from "../components/ipad/IpadCounter";
import { IpadGifts } from "../components/ipad/IpadGifts";
import { IpadTerms } from "../components/ipad/IpadTerms";
import { IpadSteps } from "../components/ipad/IpadSteps";
import { IpadServices } from "../components/ipad/IpadServices";
import { buildMeta, SITE_URL } from "../lib/site";
import {
  faqItems,
  GIFTS_LEFT,
  GIFT_VALUE,
  OFFER_DEADLINE_ISO,
  OFFER_DEADLINE_LABEL,
  OFFER_START_ISO,
} from "../content/ipad-offer";

const title = "iPad Pro на M5 в подарок — спецпредложение hay.agency";
const description = `Подарок за проект: iPad Pro на M5, iPhone или сертификат на технику при заказе разработки и продвижения. Осталось ${GIFTS_LEFT} подарков, акция до ${OFFER_DEADLINE_LABEL}.`;

const offerJsonLd = {
  "@context": "https://schema.org",
  "@type": "Offer",
  "@id": `${SITE_URL}/ipad#offer`,
  name: "iPad Pro на M5 в подарок при заказе разработки и продвижения",
  description,
  url: `${SITE_URL}/ipad`,
  availableAtOrFrom: { "@id": `${SITE_URL}/#organization` },
  offeredBy: { "@id": `${SITE_URL}/#organization` },
  validFrom: OFFER_START_ISO,
  validThrough: OFFER_DEADLINE_ISO,
  eligibleQuantity: {
    "@type": "QuantitativeValue",
    value: GIFTS_LEFT,
    unitText: "шт.",
  },
  itemOffered: {
    "@type": "Product",
    name: "iPad Pro на M5 (или равнозначный подарок на выбор)",
  },
  priceSpecification: {
    "@type": "PriceSpecification",
    price: 0,
    priceCurrency: "RUB",
    valueAddedTaxIncluded: true,
  },
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: { "@type": "Answer", text: item.a },
  })),
};

export const Route = createFileRoute("/ipad")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/ipad",
      noindex: true,
      image: `${SITE_URL}/og/default.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "hay.agency",
      locale: "ru_RU",
    }),
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(offerJsonLd) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd) },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <ServicePageLayout breadcrumb="Спецпредложение">
      <IpadHero />
      <IpadCounter />
      <IpadGifts />
      <IpadTerms />
      <IpadSteps />
      <ClientsMarquee bare />
      <IpadServices />
      <Faq
        compact
        title="Частые вопросы об акции"
        items={faqItems}
        lead="Собрали вопросы, которые чаще всего задают про акцию. Если вашего нет — напишите, ответим честно."
      />
      <LeadForm
        id="ipad-form"
        title={
          <>
            Забронируйте подарок{" "}
            <span className="text-display-muted">за своим проектом</span>
          </>
        }
        lead="Ответим в течение рабочего дня, обсудим задачу и закрепим подарок за вами на 5 рабочих дней."
        submitLabel="Забронировать подарок"
        withSelect
        selectOptions={[
          "Интернет-магазин",
          "Корпоративный сайт",
          "Лендинг на Tilda",
          "SEO продвижение",
          "Контекстная реклама",
          "Внедрение CRM",
          "Комплексный проект",
        ]}
      />
    </ServicePageLayout>
  );
}
